export const projectsList = [
  //new projects
  {
    title: "Uzer khan Portfolio ",
    image: "/assets/images/portfolio/uzerkhan/uzerkhan-portfolio.png",
    categoryLabel: "Web Application",
    category: "Web",
    url: "/details/uzerkhan-web",
  },
  {
    title: "EAuctionsHub ",
    image: "/assets/images/portfolio/eauctionshub-web/eauctionshub-home-1.png",
    categoryLabel: "Web Application",
    category: "Web",
    url: "/details/euactionshub-web",
  },

  {
    title: "Rojgar Manpower App (Android & IOS) ",
    image:
      "/assets/images/portfolio/rojgar-manpower-app/simply-rojgar-manpower-app-web-page-english.png",
    categoryLabel: "App Development",
    category: "App",
    url: "/details/rojgar-manpower-app",
  },
  {
    title: "Rojgar Manpower Hiring App ( Android & IOS ) ",
    image:
      "/assets/images/portfolio/rojgar-manpower-hiring-app/simply-rojgar-manpower-hiring-web-page.png",
    categoryLabel: "App Development",
    category: "App",
    url: "/details/rojgar-manpower-hiring-app",
  },
  {
    title: "EAuctionsHub App (Android & IOS ) ",
    image:
      "/assets/images/portfolio/eauctionshub-app/eauctionshub-app-desktop-size.png",
    categoryLabel: "App Development",
    category: "App",
    url: "/details/euactionshub-app",
  },
  //old projects
  {
    title: "ReportOne",
    image: "/assets/images/portfolio/report-one-web/image (1).png",
    categoryLabel: "Web Application",
    category: "Web",
    url: "/details/report-one-web",
  },
  {
    title: "FolderOne",
    image: "/assets/images/portfolio/folder-one-web/image1.png",
    categoryLabel: "Web Application",
    category: "Web",
    url: "/details/folder-one-web",
  },
  {
    title: "ReportOne App ( IOS )",
    image: "/assets/images/portfolio/report-one-mobile/image1.png",
    categoryLabel: "App-Development",
    category: "App",
    url: "/details/report-one-ios",
  },
  {
    title: "ReportOne App ( Android )",
    image: "/assets/images/portfolio/report-one-mobile/image3.png",
    categoryLabel: "App-Development",
    category: "App",
    url: "/details/report-one-android",
  },
  {
    title: "Pitchlane",
    image: "/assets/images/portfolio/pitchlane-web/image3.png",
    categoryLabel: "Web Application",
    category: "Web",
    url: "/details/pitchlane-web",
  },
];

export const tabs = ["Web", "App"];
